/* Clocked Out PC — build configurator
   -----------------------------------------------------------------------
   How pricing stays safe:
   Every selectable upgrade is a real Shopify product/variant with its own
   price set in Shopify Admin. The configurator only *displays* prices —
   when the build is added to the cart, each selection is added as its own
   line item and Shopify's servers price every line. Nothing in this file
   (or anything a customer edits in their browser) can change what is
   charged at checkout.

   Compatibility model (owner-managed via metafields, see docs):
   - The base PC provides "tokens" (e.g. socket-am5, psu-650, case-atx).
   - Each option may LIST:  requires  (tokens that must be present),
                            excludes  (tokens that must NOT be present),
                            provides  (tokens it adds when selected).
   - An option is available when all requires are met by base+other
     selections and no exclusion conflicts exist. Invalid selections are
     disabled in the UI with the owner-written reason (compat note).
   ----------------------------------------------------------------------- */
(function () {
  'use strict';

  var root = document.querySelector('[data-configurator]');
  if (!root) return;

  var dataEl = root.querySelector('[data-configurator-data]');
  if (!dataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (err) {
    console.error('Configurator: invalid data JSON', err);
    return;
  }

  var form = root.querySelector('[data-configurator-form]');
  var totalEl = root.querySelector('[data-config-total]');
  var stickyPriceEls = document.querySelectorAll('[data-sticky-price]');
  var summaryRows = root.querySelector('[data-config-summary-rows]');
  var errorEl = root.querySelector('[data-config-error]');
  var addBtn = root.querySelector('[data-config-add]');

  /* Index options by input value (option id) */
  var optionsById = {};
  DATA.groups.forEach(function (group) {
    group.options.forEach(function (opt) {
      opt.groupKey = group.key;
      opt.groupTitle = group.title;
      optionsById[opt.id] = opt;
    });
  });

  function getSelections() {
    var selections = {};
    DATA.groups.forEach(function (group) {
      var checked = form.querySelector('input[name="config-' + group.key + '"]:checked');
      selections[group.key] = checked ? optionsById[checked.value] : null;
    });
    return selections;
  }

  function tokensFrom(selections, excludeGroupKey) {
    var tokens = DATA.base.tokens.slice();
    Object.keys(selections).forEach(function (key) {
      if (key === excludeGroupKey) return;
      var opt = selections[key];
      if (opt && opt.provides) tokens = tokens.concat(opt.provides);
    });
    return tokens;
  }

  function unavailableReason(opt, selections) {
    if (opt.soldOut) return opt.soldOutNote || 'Temporarily unavailable';
    var active = tokensFrom(selections, opt.groupKey);

    var missing = (opt.requires || []).filter(function (t) { return active.indexOf(t) === -1; });
    if (missing.length) return opt.note || ('Requires: ' + missing.join(', '));

    var conflict = (opt.excludes || []).some(function (t) { return active.indexOf(t) !== -1; });
    if (conflict) return opt.note || 'Not compatible with your current selection';

    /* Reverse check: does any selected option in another group exclude what this provides? */
    var provided = opt.provides || [];
    var reverse = Object.keys(selections).some(function (key) {
      if (key === opt.groupKey) return false;
      var sel = selections[key];
      if (!sel || !sel.excludes) return false;
      return sel.excludes.some(function (t) { return provided.indexOf(t) !== -1; });
    });
    if (reverse) return opt.note || 'Not compatible with your current selection';

    return null;
  }

  function update(changedInput) {
    var selections = getSelections();
    var reverted = [];

    /* Pass 1: availability. Repeat until stable (a revert can free/blocked others). */
    for (var pass = 0; pass < 4; pass++) {
      var changed = false;
      DATA.groups.forEach(function (group) {
        group.options.forEach(function (opt) {
          var input = form.querySelector('input[value="' + opt.id + '"]');
          if (!input) return;
          var wrap = input.closest('.config-option');
          var reason = unavailableReason(opt, selections);
          var blocked = !!reason;
          wrap.classList.toggle('is-disabled', blocked);
          input.disabled = blocked;
          var reasonEl = wrap.querySelector('.config-option__blocked');
          if (reasonEl) reasonEl.textContent = blocked ? reason : '';

          if (blocked && input.checked) {
            /* Revert this group to its first available option (usually "included"). */
            var fallback = null;
            for (var i = 0; i < group.options.length; i++) {
              var cand = group.options[i];
              if (cand.id === opt.id) continue;
              if (!unavailableReason(cand, selections)) { fallback = cand; break; }
            }
            if (fallback) {
              var fbInput = form.querySelector('input[value="' + fallback.id + '"]');
              if (fbInput) {
                fbInput.checked = true;
                selections[group.key] = fallback;
                reverted.push(group.title);
                changed = true;
              }
            }
          }
        });
      });
      if (!changed) break;
    }

    /* Pass 2: totals + summary */
    var total = DATA.base.price;
    var summaryHtml = '';
    DATA.groups.forEach(function (group) {
      var sel = selections[group.key];
      var label = sel ? sel.label : '—';
      var delta = sel ? sel.price : 0;
      total += delta;

      var selectedEl = form.querySelector('[data-group-selected="' + group.key + '"]');
      if (selectedEl) {
        selectedEl.textContent = label + (delta > 0 ? ' · +' + window.COP.formatMoney(delta) : '');
      }
      summaryHtml += '<div class="spec-row"><span>' + escapeHtml(group.title) + '</span><span>' +
        escapeHtml(label) + (delta > 0 ? ' <b style="color:var(--c-accent)">+' + window.COP.formatMoney(delta) + '</b>' : '') +
        '</span></div>';
    });

    if (summaryRows) summaryRows.innerHTML = summaryHtml;
    if (totalEl) totalEl.textContent = window.COP.formatMoney(total);
    stickyPriceEls.forEach(function (el) { el.textContent = window.COP.formatMoney(total); });

    if (reverted.length && changedInput) {
      window.COP.toast('Updated ' + reverted.join(', ') + ' — previous choice was not compatible.');
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  form.addEventListener('change', function (e) {
    if (e.target.matches('input[type="radio"]')) update(e.target);
  });

  /* ---------- Add configured build to cart ---------- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (errorEl) { errorEl.classList.remove('is-visible'); errorEl.textContent = ''; }

    var selections = getSelections();

    /* Final client-side validation before submit */
    var invalid = [];
    Object.keys(selections).forEach(function (key) {
      var sel = selections[key];
      if (sel && unavailableReason(sel, selections)) invalid.push(sel.groupTitle);
    });
    if (invalid.length) {
      showError('Please review: ' + invalid.join(', ') + ' — the selected option is not compatible.');
      return;
    }

    var configId = 'CFG-' + Date.now().toString(36).toUpperCase() + '-' +
      Math.random().toString(36).slice(2, 6).toUpperCase();

    /* Readable configuration properties stored on the base line item.
       These are saved on the order permanently, so the exact build is
       preserved in Shopify Admin, emails and order history. */
    var baseProperties = { '_config_id': configId };
    var items = [];

    DATA.groups.forEach(function (group) {
      var sel = selections[group.key];
      if (!sel) return;
      baseProperties[group.title] = sel.label + (sel.price > 0 ? ' (+' + window.COP.formatMoney(sel.price) + ')' : '');
      if (sel.variantId) {
        items.push({
          id: sel.variantId,
          quantity: 1,
          properties: {
            '_config_id': configId,
            '_config_role': 'upgrade',
            'Applies to': DATA.base.title
          }
        });
      }
    });

    /* Base goes first so it leads the group in the cart */
    items.unshift({
      id: DATA.base.variantId,
      quantity: 1,
      properties: baseProperties
    });

    setLoading(true);
    fetch(window.COP.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (json) { return { ok: r.ok, json: json }; });
      })
      .then(function (res) {
        setLoading(false);
        if (!res.ok) {
          showError(res.json.description || res.json.message || 'Could not add this build to the cart. Please try again.');
          return;
        }
        window.COP.refreshCartCount();
        window.COP.toast('Build added to cart', { actionHref: window.COP.cartUrl, actionLabel: 'View cart' });
      })
      .catch(function () {
        setLoading(false);
        showError('Network error — your build was not added. Please check your connection and try again.');
      });
  });

  function showError(msg) {
    if (errorEl) {
      errorEl.textContent = msg;
      errorEl.classList.add('is-visible');
      errorEl.focus && errorEl.focus();
    } else {
      window.COP.toast(msg);
    }
  }

  function setLoading(loading) {
    if (!addBtn) return;
    addBtn.classList.toggle('is-loading', loading);
    addBtn.disabled = loading;
  }

  update(null);
})();
